export default "__VITE_ASSET__BnUIDeD2__"